import React from 'react';
import styleClasses from '../../containers/order/order.module.scss';
import { INotAvailable } from '../../models/button';

const NotAvailable: React.FC<INotAvailable> = ({ selectedBtnStyle }) => {
  return (
    <button
      type="button"
      className={`${styleClasses.item_select_btn} btn item-select-btn mb-3`}
      style={{
        ...selectedBtnStyle,
      }}
      disabled={true}
      data-testid="unavailableButton"
    >
      Unavailable
    </button>
  );
};

export default NotAvailable;
